/** @jsx h */
import { searchHeading, searchIntro } from '../config';
import { useEffect } from 'preact/hooks';
import { Fragment } from 'preact';
import { ClickRedirect } from '@3pc/click-redirect';

const Teaser = ({ initialSearchData }) => {
  const results = initialSearchData.documents.list.results;

  useEffect(() => {
    // init click redirect on every resultlist update
    const clickRedirectList = ClickRedirect.InitViaDom();
    clickRedirectList.forEach(clickRedirect => clickRedirect.activate());
  }, [results]);

  return (
    <Fragment>
      <h2 className="grid-teaser__heading">{searchHeading}</h2>
      <p className="grid-teaser__intro text-l">{searchIntro}</p>
      {results?.length ? (
        <ul className="grid-teaser__list col--3">
          {results.map((result, index) => {
            return (
              <li
                className="grid-teaser__item click-redirect-parent"
                key={index}
              >
                <article className="grid-teaser__content">
                  {result.url && (
                    <h3 className="grid-teaser__title">
                      <a
                        href={result.url}
                        className="grid-teaser__item-link click-redirect-target"
                        {...(result.urlType === 'external'
                          ? { target: '_blank', rel: 'noopener noreferrer' }
                          : {})}
                      >
                        {result.title}
                      </a>
                    </h3>
                  )}
                  {result.url && result.urlLabel && (
                    <span
                      className={`link-${result.urlType} grid-teaser__link text click-redirect-source`}
                      data-click-redirect
                    >
                      <span>{result.urlLabel}</span>
                    </span>
                  )}
                </article>
              </li>
            );
          })}
        </ul>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default Teaser;
